import { useContext } from 'react';

import { IdentitiesContext } from './IdentitiesContext';

export const useIdentitiesContext = () => {
  const context = useContext(IdentitiesContext);
  if (!context) {
    throw new Error('useIdentitiesContext must be used within an IdentitiesProvider');
  }
  return context;
};
